export default __webpack_public_path__ + "static/media/630.9f8da00f.png";